<template>
  <v-progress-linear
    :indeterminate="indeterminate"
    rounded
    :buffer-value="bufferValue"
    :color="color"
    :height="height"
    :value="value"
  />
</template>

<script>
export default {
  name: 'BaseLoadingLinear',
  props: {
    indeterminate: {
      type: Boolean,
      default: true,
    },
    bufferValue: {
      type: String,
      default: '0',
    },
    color: {
      type: String,
      default: 'info',
    },
    height: {
      type: Number,
      default: 15,
    },
    value: {
      type: Number,
      default: 10,
    },
  },
};
</script>
